import { useState } from 'react'
import { Info } from 'lucide-react'
import BadgeCard from './BadgeCard'

const ALL_BADGES_STATIC = [
  {
    badgeKey: 'agenda_starter',
    definition: {
      badgeKey: 'agenda_starter',
      name: 'Agenda Starter',
      description: 'Created your first meeting with an agenda (3+ items).',
      category: 'agenda',
    },
  },
  {
    badgeKey: 'agenda_builder',
    definition: {
      badgeKey: 'agenda_builder',
      name: 'Agenda Builder',
      description: 'Built a meeting with 5+ agenda items, each with timeboxes.',
      category: 'agenda',
    },
  },
  {
    badgeKey: 'agenda_pro',
    definition: {
      badgeKey: 'agenda_pro',
      name: 'Agenda Pro',
      description: 'Created a structured agenda with timeboxes and descriptions on every item.',
      category: 'agenda',
    },
  },
  {
    badgeKey: 'decision_minded',
    definition: {
      badgeKey: 'decision_minded',
      name: 'Decision Minded',
      description: 'Set at least one agenda item as "requires decision" so outcomes are clear.',
      category: 'agenda',
    },
  },
  {
    badgeKey: 'outputs_all_closed',
    definition: {
      badgeKey: 'outputs_all_closed',
      name: 'Closer Champion',
      description: 'Marked all outstanding actionable outputs from a prior recurring meeting as completed.',
      category: 'outputs',
    },
  },
  {
    badgeKey: 'scorecard_90',
    definition: {
      badgeKey: 'scorecard_90',
      name: 'Meeting Ace',
      description: 'Your meeting scored 90 or above on the Rithmo scorecard.',
      category: 'performance',
    },
  },
  {
    badgeKey: 'scorecard_95',
    definition: {
      badgeKey: 'scorecard_95',
      name: 'Meeting Excellence',
      description: 'Your meeting scored 95 or above on the Rithmo scorecard.',
      category: 'performance',
    },
  },
  {
    badgeKey: 'scorecard_100',
    definition: {
      badgeKey: 'scorecard_100',
      name: 'Perfect Run',
      description: 'Your meeting hit a perfect 100 on the Rithmo scorecard.',
      category: 'performance',
    },
  },
  {
    badgeKey: 'meeting_centurion',
    definition: {
      badgeKey: 'meeting_centurion',
      name: 'Meeting Centurion',
      description: '100 qualified meetings as organizer—triple digits, unlocked.',
      category: 'milestone',
    },
  },
  {
    badgeKey: 'meeting_kilomeet',
    definition: {
      badgeKey: 'meeting_kilomeet',
      name: 'Kilomeet Legend',
      description: "1,000 qualified meetings. You're basically infrastructure.",
      category: 'milestone',
    },
  },
  {
    badgeKey: 'team_century_squad',
    definition: {
      badgeKey: 'team_century_squad',
      name: 'Century Squad',
      description: 'Your team logged 100 qualified meetings together.',
      category: 'milestone',
    },
  },
  {
    badgeKey: 'team_kilomeet_armada',
    definition: {
      badgeKey: 'team_kilomeet_armada',
      name: 'Kilomeet Armada',
      description: 'Your team logged 1,000 qualified meetings. Fleet mode.',
      category: 'milestone',
    },
  },
]

export default function AllBadgesTooltip() {
  const [open, setOpen] = useState(false)

  return (
    <div
      className="relative inline-flex items-center"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className="p-0.5 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500/30"
        aria-label="See all possible badges you can earn"
      >
        <Info className="w-4 h-4" strokeWidth={2.25} />
      </button>
      {open && (
        <div className="absolute z-[100] mt-2 right-0 w-[min(100vw-2rem,480px)] rounded-xl border border-gray-600 bg-gray-900 shadow-xl p-4 text-xs text-gray-200">
          <p className="mb-3">
            These are the badges you can earn in Rithmo. You&apos;ll see them here once you unlock them.
          </p>
          <div className="max-h-[340px] overflow-y-auto pr-1">
            <div className="flex flex-wrap gap-2">
              {ALL_BADGES_STATIC.map((badge) => (
                <BadgeCard key={badge.badgeKey} badge={badge} />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

